import React from "react";
import { Tabs } from "antd";
import styled from "@emotion/styled";
import { useSearchParams } from "react-router-dom";
import SensitiveSearchPage from "./SensitiveSearchPage";
import EpisodeIndexPage from "./EpisodeIndexPage";

// Match the rest of the app: full-width white page that fills the content area
// below the fixed 64px header (same pattern as other pages' PageContent).
const PageContent = styled.div`
  background: #fff;
  width: 100%;
  min-height: calc(100vh - 130px);
`;

/**
 * Single page that hosts the three sensitive-search tools as tabs. The active
 * tab is kept in the URL (?tab=) so it is shareable/bookmarkable. Inactive tabs
 * are rendered lazily on first open and then stay mounted, so search results are
 * preserved when switching between tabs.
 */
const SensitiveSearch: React.FC = () => {
  const [params, setParams] = useSearchParams();
  const active = params.get("tab") || "search";

  const onChange = (key: string) => setParams({ tab: key });

  return (
    <PageContent>
      <Tabs
        activeKey={active}
        onChange={onChange}
        tabBarStyle={{
          paddingLeft: 24,
          marginBottom: 0,
          background: "#fff",
          position: "sticky",
          top: 64, // sits just below the app's fixed 64px header
          zIndex: 10,
          boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
        }}
        items={[
          { key: "search", label: "Topic Search", children: <SensitiveSearchPage /> },
          { key: "index", label: "Episode Index", children: <EpisodeIndexPage /> },
        ]}
      />
    </PageContent>
  );
};

export default SensitiveSearch;
